import React, { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import MarketingCard from "./MarketingCard";
import { marketingData, marketingCategories } from "./marketingData";
import "./MarketingServices.css";

function Marketing() {
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm]);

  const toggleCategory = (serviceName) => {
    setSelectedCategories((prev) =>
      prev.includes(serviceName)
        ? prev.filter((c) => c !== serviceName)
        : [...prev, serviceName],
    );
  };

  const filteredData = useMemo(() => {
    return marketingData.filter((service) => {
      const matchesSearch =
        service.title?.toLowerCase().includes(debouncedSearch.toLowerCase()) ||
        service.description
          ?.toLowerCase()
          .includes(debouncedSearch.toLowerCase()) ||
        service.category?.toLowerCase().includes(debouncedSearch.toLowerCase());

      const matchesCategory =
        selectedCategories.length === 0 ||
        selectedCategories.includes(service.title);

      return matchesSearch && matchesCategory;
    });
  }, [debouncedSearch, selectedCategories]);

  return (
    <div className="ms-wrapper">
      <Header />

      {/* Hero Section */}
      <div
        className="ms-hero"
        style={{
          backgroundImage:
            "url(assets/img/marketing/accelerate_your_growth_hero_image.jpg)",
        }}
      >
        <div className="container">
          <div className="ms-hero-content">
            <p
              style={{
                marginBottom: "16px",
                fontSize: "13px",
                fontWeight: 700,
                letterSpacing: "0.15em",
                textTransform: "uppercase",
                color: "#ffffffff",
              }}
            >
              ✦ Marketing Services
            </p>
            <h1 className="ms-hero-title">
              Accelerate Your Growth
              <br />
              with Expert Marketing
            </h1>
            <p className="ms-hero-subtitle">
              Comprehensive crypto marketing solutions — from token launches and
              influencer campaigns to community building and fundraising
              strategy.
            </p>

            {/* Stats row */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "48px",
                marginTop: "40px",
                flexWrap: "wrap",
              }}
            >
              {[
                { value: `${marketingData.length}+`, label: "Services" },
                { value: "5", label: "Categories" },
                { value: "100%", label: "Results-Driven" },
              ].map((stat, i) => (
                <div
                  key={i}
                  className="ms-animate-fadeInUp"
                  style={{
                    animationDelay: `${0.3 + i * 0.1}s`,
                    textAlign: "center",
                  }}
                >
                  <div
                    style={{
                      fontSize: "30px",
                      fontWeight: 800,
                      color: "#e4e4e4ff",
                      letterSpacing: "-0.03em",
                    }}
                  >
                    {stat.value}
                  </div>
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#94a3b8",
                      fontWeight: 500,
                      marginTop: "4px",
                    }}
                  >
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="ms-container">
        <div className="ms-layout">
          {/* Overlay for mobile */}
          <div
            className={`ms-filter-overlay ${isFilterOpen ? "visible" : ""}`}
            onClick={() => setIsFilterOpen(false)}
          />

          {/* Sidebar */}
          {/* <aside className={`ms-sidebar ${isFilterOpen ? "open" : ""}`}>
            <button
              className="ms-sidebar-close"
              onClick={() => setIsFilterOpen(false)}
            >
              <i className="fas fa-times" />
            </button>

            <div className="ms-sidebar-header">
              <span className="ms-filter-title">Filter By Service</span>
              {selectedCategories.length > 0 && (
                <button
                  className="ms-clear-btn"
                  onClick={() => setSelectedCategories([])}
                >
                  Clear ({selectedCategories.length})
                </button>
              )}
            </div>

            <div className="ms-sidebar-content-wrapper" style={{ padding: '4px' }}>
              <div className="ms-filter-scroll" style={{ paddingRight: '12px' }}>
                <ul className="ms-filter-list" style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {marketingData.map((service) => {
                    const isActive = selectedCategories.includes(service.title);
                    return (
                      <li
                        key={service.title}
                        className={`ms-modern-filter-item ${isActive ? "active" : ""}`}
                        style={{
                          '--item-color': service.accentColor,
                          background: isActive ? `${service.accentColor}12` : '#ffffff',
                          border: isActive ? `1px solid ${service.accentColor}40` : '1px solid #f8fafc',
                          boxShadow: isActive ? `0 4px 12px ${service.accentColor}15` : '0 2px 6px rgba(0,0,0,0.02)',
                        }}
                      >
                        <label className="ms-modern-filter-label">
                          <input
                            type="checkbox"
                            className="ms-hidden-checkbox"
                            checked={isActive}
                            onChange={() => toggleCategory(service.title)}
                          />
                          <div className="ms-icon-wrapper" style={{
                            background: isActive ? service.accentColor : '#f1f5f9',
                            color: isActive ? '#fff' : '#64748b',
                            boxShadow: isActive ? `0 4px 10px ${service.accentColor}40` : 'none'
                          }}>
                            <i className={service.icon} />
                          </div>
                          <span className="ms-filter-text" style={{
                            color: isActive ? '#0f172a' : '#64748b',
                            fontWeight: isActive ? '700' : '600'
                          }}>
                            {service.title}
                          </span>

                          <div className={`ms-check-indicator ${isActive ? 'visible' : ''}`} style={{ color: service.accentColor }}>
                            <i className="fas fa-check-circle" />
                          </div>
                        </label>
                      </li>
                    );
                  })}
                </ul>
              </div>
            </div>
          </aside> */}

          {/* Main Content */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className="ms-mobile-filter-bar">
              <button
                className="ms-mobile-filter-btn"
                onClick={() => setIsFilterOpen(true)}
              >
                <i className="fas fa-sliders-h" /> Filters
                {selectedCategories.length > 0 && (
                  <span
                    style={{
                      background: "#fff",
                      color: "#6366f1",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "11px",
                      fontWeight: 800,
                    }}
                  >
                    {selectedCategories.length}
                  </span>
                )}
              </button>
            </div>

            <div className="ms-topbar">
              <div className="ms-search-box">
                <i className="fas fa-search ms-search-icon" />
                <input
                  type="text"
                  placeholder="Search marketing services, strategies..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              <div className="ms-stats">
                {filteredData.length} of {marketingData.length} results
              </div>
            </div>

            <div className="ms-grid">
              {filteredData.length > 0 ? (
                filteredData.map((service, idx) => (
                  <MarketingCard
                    key={service.id}
                    service={service}
                    index={idx}
                    onClick={(s) => navigate(`/marketing/${s.id}`)}
                  />
                ))
              ) : (
                <div className="ms-empty-state">
                  <i
                    className="fas fa-ghost"
                    style={{
                      fontSize: "56px",
                      marginBottom: "24px",
                      opacity: 0.3,
                      display: "block",
                    }}
                  />
                  <h3
                    style={{
                      fontSize: "22px",
                      fontWeight: 700,
                      marginBottom: "8px",
                    }}
                  >
                    No services found
                  </h3>
                  <p style={{ color: "#64748b" }}>
                    Try adjusting your search or filters to discover more
                    services.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Marketing;
